// @ts-expect-error
import VideoLayout from '../../../modules/UI/videolayout/VideoLayout';
import { createSlice } from '@reduxjs/toolkit';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { MODERATOR_CONTROLLER_KEY } from './constant';
import { closeChat } from '../chat/actions.any';
import { close as closeParticipantPane } from '../participants-pane/actions.any';
const initialState = {
    isOpen: false
};
export const setOpenDialog = () => (dispatch, getState) => {
    dispatch(closeChat());
    dispatch(closeParticipantPane());
    dispatch(setOpenChatDialog());
};
export const toggleDialog = () => (dispatch, getState) => {
    dispatch(closeChat());
    dispatch(closeParticipantPane());
    dispatch(toggleModDialog());
    VideoLayout.onResize();
};
const moderatorController = createSlice({
    name: MODERATOR_CONTROLLER_KEY,
    initialState,
    reducers: {
        setOpenChatDialog: (state) => {
            state.isOpen = true;
        },
        setCloseDialog: (state) => {
            state.isOpen = false;
        },
        toggleModDialog: (state) => {
            state.isOpen = !state.isOpen;
        },
    }
});
ReducerRegistry.register(MODERATOR_CONTROLLER_KEY, moderatorController.reducer);
export const { 
// setOpenDialog,
setOpenChatDialog, setCloseDialog, toggleModDialog } = moderatorController.actions;
export default moderatorController.reducer;
